import { FormControl, TextField } from "@mui/material";
import { default as React, useEffect } from "react";
import { Theme, createStyles, makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    formControl: {
      margin: theme.spacing(1),
      marginLeft: 0,
      marginRight: 0,
      width: "100%",
    },
  })
);

export interface Form0x14900000 {
  countBlocks: number;
}

export function Command0x14900000(props) {
  const classes = useStyles();
  const { value, handleChange } = props;

  const commandForm = {
    countBlocks: 0,
  };

  const [fields, setFields] = React.useState<Form0x14900000>(commandForm);

  const handleChangeField =
    (prop: keyof Form0x14900000) =>
    (event: React.ChangeEvent<HTMLInputElement>) => {
      handleChange(JSON.stringify({ ...fields, [prop]: event.target.value }));
    };

  useEffect(() => {
    const params = JSON.parse(value);

    if (!params.countBlocks) {
      params.countBlocks = 0;
    }

    setFields(params);
  }, [value]);

  return (
    <>
      <FormControl className={classes.formControl}>
        <TextField
          type="number"
          inputProps={{ min: 0 }}
          id="countBlocks"
          label="Количество блоков прикладной программы"
          margin="dense"
          fullWidth
          value={fields.countBlocks}
          onChange={handleChangeField("countBlocks")}
        />
      </FormControl>
    </>
  );
}
